// extracted by mini-css-extract-plugin
export default {"Ranseq_app":"Ransep_Ranseq_app__zNjG-","Ranseq_title":"Ransep_Ranseq_title__sx707","CollTtitle":"Ransep_CollTtitle__aKpaz"};